"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
var updateTransition = function updateTransition(from, to, custom) {
	// transition routes
	this.transition = {
		from: from,
		to: to,
		custom: custom
	};
};

exports.default = updateTransition;


//////////////////
// WEBPACK FOOTER
// /Users/yinminpan/Local Dev/business-events-tas/wp-content/themes/b-e-tas/node_modules/swup/lib/modules/updateTransition.js
// module id = 58
// module chunks = 0